// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = require('../internals/add-to-unscopables');

addToUnscopables('flatMap');



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/modules/es.array.unscopables.flat-map.js
// module id = 1735
// module chunks = 1